module.exports = __webpack_public_path__ + "img/form_elements.88196882.svg";